import { BluTextField } from "@bludata/components";
import { Typography } from "@mui/material";
import React from "react";
import { memo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store";

export const Description = memo(() => {
  const watch = useWatch({ name: "description" });
  const { setValue, trigger } = useFormContext();
  const { openForm } = useSelector((state: RootState) => state.studiRoot);

  return (
    <>
      <div style={{ width: "100%" }}>
        <Typography variant="subtitle2" sx={{ p: "3px 0px 0 0" }}>
          Descrizione
        </Typography>
        <BluTextField
          disabled={openForm === "info"}
          value={watch}
          name="Description"
          multiline
          rows={3}
          onChange={(event: any) => {
            setValue("description", event.target.value);
            trigger();
          }}
        />
      </div>
    </>
  );
});
